export const isMobileNumber = (number) => {
    const prefixes = ['003106', '00316', '3106', '316', '06'];
    return prefixes.some((prefix) => new RegExp(`^${prefix}`).test(number));
};
